document
  .querySelector("#cart-count-desktop")
  .addEventListener("click", function (e) {
    e.preventDefault();
    console.log(e);
    if (e.target.nodeName == "A" && e.target.getAttribute("title") != "Cart") {
      window.location.href = e.target.getAttribute("href");
    }
    if (e.target.closest("form")) {
      e.target.closest("form").submit();
    }
    const li = e.target.closest("li");
    if (li.classList.contains("avoid")) {
      li.classList.add("hover");
      li.classList.remove("avoid");
    } else {
      li.classList.add("avoid");
      li.classList.remove("hover");
    }
  });

(function () {
  const selectors = {
    singleOption: ".single-option-selector.selector.single-option-selector-0",
    productMediaThumb: "[data-product-media-thumb]",
    productMediaThumbActive:
      "[data-product-media-thumb]:has([aria-current='true'])",
    currentMainSlideActive: ".variant-image.visible",
  };

  const singleOption = document.querySelector(selectors.singleOption);

  if (!singleOption) return;

  singleOption.addEventListener("change", function (e) {
    setTimeout(() => {
      const activeThumb = document.querySelector(
        selectors.productMediaThumbActive
      );
      activeThumb
        .querySelector("button.img-align")
        .setAttribute("aria-current", false);

      const currentActiveImageId = document.querySelector(
        selectors.currentMainSlideActive
      ).dataset.imageId;

      const newActiveThumb = document.querySelector(
        `${selectors.productMediaThumb}[data-image-id="${currentActiveImageId}"]`
      );

      newActiveThumb
        .querySelector("button.img-align")
        .setAttribute("aria-current", true);
      
      // Move the thumbnail slider to the active thumbnail
      if (newActiveThumb) {
        const slideIndex = newActiveThumb.getAttribute('data-gslide');
        if (slideIndex !== null) {
          // Find the thumbnail slider container
          const thumbnailSlider = newActiveThumb.closest('.glider');
          if (thumbnailSlider) {
            const gliderInstance = thumbnailSlider._glider;
            if (gliderInstance) {
              gliderInstance.scrollItem(parseInt(slideIndex));
            }
          }
        }
      }
      
      console.log(newActiveThumb);
      console.log(activeThumb);
    }, 500);
  });
})();

// Arizona Store menu item styling
(function() {
  function applyArizonaStoreStyling() {
    const menuLinks = document.querySelectorAll('.header-navigation nav .responsiveMenu li a');
    menuLinks.forEach(link => {
      const linkText = link.textContent.toLowerCase().trim();
      const linkHref = link.href.toLowerCase();
      const linkTitle = link.title.toLowerCase();
      
      if (linkText.includes('arizona') || linkHref.includes('arizona') || linkTitle.includes('arizona')) {
        link.classList.add('arizona-store-menu-item');
        link.style.color = '#C8642C';
        link.style.fontWeight = 'bold';
        link.style.backgroundColor = 'transparent';
        link.style.background = 'transparent';
      }
    });
  }
  
  // Apply styling when DOM is loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyArizonaStoreStyling);
  } else {
    applyArizonaStoreStyling();
  }
  
  // Reapply styling when menu is updated (for dynamic content)
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' && mutation.target.classList.contains('responsiveMenu')) {
        applyArizonaStoreStyling();
      }
    });
  });
  
  const menuContainer = document.querySelector('.header-navigation nav .responsiveMenu');
  if (menuContainer) {
    observer.observe(menuContainer, { childList: true, subtree: true });
  }
})();

// Override ALL login URLs to point to copperstateflorida.com
(function() {
  function updateAllLoginUrls() {
    // Find ALL login links - no restrictions
    const allLoginLinks = document.querySelectorAll('a[href*="/account/login"]');
    allLoginLinks.forEach(link => {
      // Skip if already pointing to the correct domain
      if (link.href.includes('copperstateflorida.com')) {
        return;
      }
      
      link.href = 'https://copperstateflorida.com/account/login';
      console.log('Updated login URL:', link);
    });
    
    // Also target any myshopify.com login links
    const myshopifyLinks = document.querySelectorAll('a[href*="myshopify.com/account/login"]');
    myshopifyLinks.forEach(link => {
      link.href = 'https://copperstateflorida.com/account/login';
      console.log('Updated myshopify login URL:', link);
    });
    
    // Target any other potential login URL patterns
    const otherLoginPatterns = [
      'a[href*="account.copperstateflorida.com"]',
      'a[href*="/account/login"]',
      'a[href*="account/login"]'
    ];
    
    otherLoginPatterns.forEach(pattern => {
      const links = document.querySelectorAll(pattern);
      links.forEach(link => {
        if (!link.href.includes('copperstateflorida.com')) {
          link.href = 'https://copperstateflorida.com/account/login';
          console.log('Updated login URL (pattern match):', link);
        }
      });
    });
  }
  
  function updateEmptyMsgText() {
    // Find and update the specific emptymsg paragraph
    const emptyMsgElements = document.querySelectorAll('.emptymsg');
    emptyMsgElements.forEach(element => {
      if (element.innerHTML.includes('Please <a href="https://copperstateflorida.com/account/login">login</a> to add items to wishlist')) {
        element.innerHTML = element.innerHTML.replace(
          'Please <a href="https://copperstateflorida.com/account/login">login</a> to add items to wishlist',
          'Please <a href="https://copperstateflorida.com/account/login">sign in</a> to add items to wishlist.'
        );
        console.log('Updated emptymsg text');
      }
    });
  }
  
  function addLoginClickHandlers() {
    // Add click handlers for any login buttons or elements that might not have href
    const loginButtons = document.querySelectorAll('button[class*="login"], button[class*="signin"], .login-button, .signin-button');
    loginButtons.forEach(button => {
      // Skip buttons that are inside forms (they should submit the form, not redirect)
      if (button.closest('form')) {
        return;
      }
      button.addEventListener('click', function(e) {
        e.preventDefault();
        window.location.href = 'https://copperstateflorida.com/account/login';
      });
    });
    
    // Also handle any elements with login-related text content
    const loginElements = document.querySelectorAll('a, button, span, div');
    loginElements.forEach(element => {
      const text = element.textContent.toLowerCase().trim();
      if ((text === 'login' || text === 'sign in' || text === 'signin') && 
          !element.href && 
          !element.closest('form')) {
        element.addEventListener('click', function(e) {
          e.preventDefault();
          window.location.href = 'https://copperstateflorida.com/account/login';
        });
      }
    });
  }

  // Run immediately
  updateAllLoginUrls();
  updateEmptyMsgText();
  addLoginClickHandlers();
  
  // Run when DOM is loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      updateAllLoginUrls();
      updateEmptyMsgText();
      addLoginClickHandlers();
    });
  }
  
  // Run periodically to catch dynamically loaded content
  setInterval(function() {
    updateAllLoginUrls();
    updateEmptyMsgText();
    addLoginClickHandlers();
  }, 1000);
  
  // Run when new content is added to the page
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        updateAllLoginUrls();
        updateEmptyMsgText();
        addLoginClickHandlers();
      }
    });
  });
  
  observer.observe(document.body, { childList: true, subtree: true });
  
  // Global click handler to catch any login-related clicks
  document.addEventListener('click', function(e) {
    const target = e.target;
    const href = target.href || target.closest('a')?.href;
    
    // Check if this is a login-related click
    if (href && (
      href.includes('/account/login') || 
      href.includes('account.copperstateflorida.com') ||
      target.textContent.toLowerCase().includes('login') ||
      target.textContent.toLowerCase().includes('sign in')
    )) {
      // Only redirect if it's not already pointing to the correct domain
      if (!href.includes('copperstateflorida.com')) {
        e.preventDefault();
        window.location.href = 'https://copperstateflorida.com/account/login';
        console.log('Global login redirect triggered for:', target);
      }
    }
  });
})();

// Add touch/swipe functionality to product image glider
(function() {
  function addSwipeToGlider() {
    const gliders = document.querySelectorAll('.glider.thumbnails');
    console.log('Found gliders for swipe:', gliders.length);
    
    gliders.forEach((glider, index) => {
      if (glider.hasAttribute('data-swipe-added')) return; // Avoid duplicate listeners
      
      console.log(`Adding swipe to glider ${index}`);
      
      let startX = 0;
      let startY = 0;
      let isHorizontalSwipe = false;
      
      glider.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        isHorizontalSwipe = false;
        console.log('Touch start:', startX, startY);
      }, { passive: true });
      
      glider.addEventListener('touchmove', (e) => {
        if (!startX || !startY) return;
        
        const currentX = e.touches[0].clientX;
        const currentY = e.touches[0].clientY;
        const diffX = Math.abs(startX - currentX);
        const diffY = Math.abs(startY - currentY);
        
        // Determine if this is a horizontal swipe
        if (diffX > diffY && diffX > 10) {
          isHorizontalSwipe = true;
          e.preventDefault(); // Prevent scrolling
        }
      }, { passive: false });
      
      glider.addEventListener('touchend', (e) => {
        if (!isHorizontalSwipe || !startX) {
          startX = 0;
          startY = 0;
          isHorizontalSwipe = false;
          return;
        }
        
        const endX = e.changedTouches[0].clientX;
        const diffX = startX - endX;
        const threshold = 30; // Minimum swipe distance
        
        console.log('Touch end - diffX:', diffX, 'threshold:', threshold);
        
        if (Math.abs(diffX) > threshold) {
          console.log('Swipe detected:', diffX > 0 ? 'left (next)' : 'right (prev)');
          
          // Try to find and click the appropriate button
          const gliderContainer = glider.closest('.glider-contain');
          if (gliderContainer) {
            if (diffX > 0) {
              // Swipe left - go to next image
              const nextBtn = gliderContainer.querySelector('.glider-button-next');
              if (nextBtn && !nextBtn.classList.contains('disabled')) {
                console.log('Clicking next button');
                nextBtn.click();
              }
            } else {
              // Swipe right - go to previous image
              const prevBtn = gliderContainer.querySelector('.glider-button-prev');
              if (prevBtn && !prevBtn.classList.contains('disabled')) {
                console.log('Clicking prev button');
                prevBtn.click();
              }
            }
          }
        }
        
        startX = 0;
        startY = 0;
        isHorizontalSwipe = false;
      }, { passive: true });
      
      // Mark as having swipe functionality added
      glider.setAttribute('data-swipe-added', 'true');
    });
  }
  
  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addSwipeToGlider);
  } else {
    addSwipeToGlider();
  }
  
  // Re-initialize when new sections are loaded
  document.addEventListener('Section:Loaded', addSwipeToGlider);
  
  // Also try to initialize after a delay to ensure glider is loaded
  setTimeout(addSwipeToGlider, 1000);
  setTimeout(addSwipeToGlider, 2000); // Try again after 2 seconds
})();

// Hide arrows when 4 or fewer images
(function() {
  function hideArrowsForFewImages() {
    const thumbnailGliders = document.querySelectorAll('.glider.thumbnails');
    
    thumbnailGliders.forEach(glider => {
      const slides = glider.querySelectorAll('.glider-slide');
      const pagination = glider.parentElement.querySelector('.glider-pagination');
      
      if (slides.length <= 4 && pagination) {
        glider.classList.add('few-images');
        pagination.style.display = 'none';
        console.log(`Hiding arrows for glider with ${slides.length} images`);
      } else if (slides.length > 4 && pagination) {
        glider.classList.remove('few-images');
        pagination.style.display = '';
        console.log(`Showing arrows for glider with ${slides.length} images`);
      }
    });
  }
  
  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideArrowsForFewImages);
  } else {
    hideArrowsForFewImages();
  }
  
  // Re-initialize when new sections are loaded
  document.addEventListener('Section:Loaded', hideArrowsForFewImages);
  
  // Also try to initialize after a delay to ensure glider is loaded
  setTimeout(hideArrowsForFewImages, 1000);
  setTimeout(hideArrowsForFewImages, 2000);
})();

// Add touch/swipe functionality to sub collections glider
(function() {
  function addSwipeToSubCollections() {
    const subCollectionGliders = document.querySelectorAll('.sub-collections .glider');
    console.log('Found sub collection gliders for swipe:', subCollectionGliders.length);
    
    subCollectionGliders.forEach((glider, index) => {
      if (glider.hasAttribute('data-swipe-added')) return; // Avoid duplicate listeners
      
      console.log(`Adding swipe to sub collection glider ${index}`);
      
      let startX = 0;
      let startY = 0;
      let isHorizontalSwipe = false;
      
      glider.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        isHorizontalSwipe = false;
        console.log('Sub collection touch start:', startX, startY);
      }, { passive: true });
      
      glider.addEventListener('touchmove', (e) => {
        if (!startX || !startY) return;
        
        const currentX = e.touches[0].clientX;
        const currentY = e.touches[0].clientY;
        const diffX = Math.abs(startX - currentX);
        const diffY = Math.abs(startY - currentY);
        
        // Determine if this is a horizontal swipe
        if (diffX > diffY && diffX > 10) {
          isHorizontalSwipe = true;
          e.preventDefault(); // Prevent scrolling
        }
      }, { passive: false });
      
      glider.addEventListener('touchend', (e) => {
        if (!isHorizontalSwipe || !startX) {
          startX = 0;
          startY = 0;
          isHorizontalSwipe = false;
          return;
        }
        
        const endX = e.changedTouches[0].clientX;
        const diffX = startX - endX;
        const threshold = 30; // Minimum swipe distance
        
        console.log('Sub collection touch end - diffX:', diffX, 'threshold:', threshold);
        
        if (Math.abs(diffX) > threshold) {
          console.log('Sub collection swipe detected:', diffX > 0 ? 'left (next)' : 'right (prev)');
          
          // Try to find and click the appropriate button
          const gliderContainer = glider.closest('.sub-collections');
          if (gliderContainer) {
            if (diffX > 0) {
              // Swipe left - go to next collection
              const nextBtn = gliderContainer.querySelector('.glider-button-next');
              if (nextBtn && !nextBtn.classList.contains('disabled')) {
                console.log('Clicking sub collection next button');
                nextBtn.click();
              }
            } else {
              // Swipe right - go to previous collection
              const prevBtn = gliderContainer.querySelector('.glider-button-prev');
              if (prevBtn && !prevBtn.classList.contains('disabled')) {
                console.log('Clicking sub collection prev button');
                prevBtn.click();
              }
            }
          }
        }
        
        startX = 0;
        startY = 0;
        isHorizontalSwipe = false;
      }, { passive: true });
      
      // Mark as having swipe functionality added
      glider.setAttribute('data-swipe-added', 'true');
    });
  }
  
  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addSwipeToSubCollections);
  } else {
    addSwipeToSubCollections();
  }
  
  // Re-initialize when new sections are loaded
  document.addEventListener('Section:Loaded', addSwipeToSubCollections);
  
  // Also try to initialize after a delay to ensure glider is loaded
  setTimeout(addSwipeToSubCollections, 1000);
  setTimeout(addSwipeToSubCollections, 2000); // Try again after 2 seconds
})();

